import throttle from 'lodash.throttle';
import { ApplicationResolution } from '../applicationResolution';
import { Mode } from '../../common/types';

export const getApplicationSize = (
  resolution: ApplicationResolution
): { width: number; height: number } => {
  return resolution === ApplicationResolution.FULLHD
    ? { width: 1920, height: 1080 }
    : { width: 1280, height: 720 };
};

export const throttleInteraction = <T extends (...args: Parameters<T>) => void>(
  func: T,
  interval = 100
) => {
  return throttle(func, interval, { trailing: false });
};

export const truncate = (
  text: string | undefined,
  maxLength: number
): string => {
  if (!text) {
    return '';
  }

  const ellipsis = '\u2026';

  if (text.length <= maxLength) {
    return text;
  }

  const hardLimitedText = text.substr(0, maxLength - ellipsis.length);
  return hardLimitedText + ellipsis;
};

export const getCSSPercentage = (percentage: number): string =>
  Number.isFinite(percentage) ? `${(percentage * 100).toFixed(2)}%` : `0%`;

export const isLowEndDevice = (mode: Mode): boolean =>
  ['elisa', 'telia', 'hbbtv', 'ps4'].includes(mode);
